import { render, staticRenderFns } from "./TableVote.vue?vue&type=template&id=558ee4a2&scoped=true&"
import script from "./TableVote.vue?vue&type=script&lang=js&"
export * from "./TableVote.vue?vue&type=script&lang=js&"
import style0 from "./TableVote.vue?vue&type=style&index=0&id=558ee4a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ee4a2",
  null
  
)

export default component.exports